import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('notConnectedSimulation')
export class NotConnectedSimulation {
  @JsonProperty('promotionalOfferInd', Boolean, true)
  public isPromotionalOffer = false;

  @JsonProperty('projectCost', Number, true)
  public loanAmount = 0;

  @JsonProperty('projectDuration', Number, true)
  public loanDuration = 0;

  @JsonProperty('loanItemId', String, true)
  public loanTypeId = '';

  @JsonProperty('monthlyPaymentProjectWithoutInsurance', Number, true)
  public monthlyPaymentExcludingInsurance = 0;

  @JsonProperty('annualTnc', Number, true)
  public tnc = 0;

  @JsonProperty('taeg', Number, true)
  public annualPercentageRateOfCharge = 0;

  @JsonProperty('globalAgios', Number, true)
  public agios = 0;

  @JsonProperty('globalFileFees', Number, true)
  public applicationFees = 0;

  @JsonProperty('globalLoanCost', Number, true)
  public totalCost = 0;

  @JsonProperty('validatedSimulationInd', String, true)
  public isValidatedSimulation = '';
}
